import { FC, useState, useEffect } from "react"
import { Card } from '@sainsburys-tech/luna-card'
import routes from "../../../RouteConfig/routespath"
import { SelectField } from "@sainsburys-tech/luna-form"
import store from "../../../Store/store"
import { useSelector } from "react-redux"
import { storeFilter } from "../../../Redux/Actions/filterActions"
import { menuHeaderPayload } from "../../../Redux/Actions/menuHeaderAction"
import { useHistory } from "react-router-dom"
import { GridWrapper, GridItem } from "@sainsburys-tech/luna-grid"
import { filterModelSelecterAndProcessData } from "../../../helpers/filterModelSelector"
import { dispatchMessageFormatter } from "../../../helpers/dispatchMessageFormatter"
import { consolelog } from "../../../helpers/consolelog"

interface ProduceMenuInterface {
    showBackBtn?: boolean
}

const ProductMenu = ({ showBackBtn }: ProduceMenuInterface) => {
    const [active, setActive] = useState(false)
    const [selectedMenu, setSelectedMenu] = useState()

    const filter = useSelector((state: any) => state.filterReducer)
    const nonDirectQueryRespnse = useSelector((state: any) => state.menuHeaderReducer?.data)
    const history = useHistory()

    const onClick = (e: any) => {
        e.preventDefault()
        setActive(!active)
    }

    useEffect(() => {
        setSelectedMenu(nonDirectQueryRespnse?.selectedMenu)
    }, [nonDirectQueryRespnse?.selectedMenu])

    const onChange = (event: any, data: any) => {
        store.dispatch(menuHeaderPayload(null))
        let item = event.target.value;
        let selectedData = data.filter((x: { value: string }) => x.value === item).map((m: any, i: any) => {
            return m.data
        })
        if (filter.data === null) {
            consolelog('I am 1')
            data = dispatchMessageFormatter('', true, "Product Menu 40", selectedData[0].name, selectedData[0].parent,
                undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)
            store.dispatch(storeFilter(data))
        } else if (filter.data.parentName === selectedData[0].parent && !filter.data.isDirectQuery) {
            consolelog('I am 2')
            data = dispatchMessageFormatter('', true, "Product Menu 44", selectedData[0].name, selectedData[0].parent,
                undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)
            store.dispatch(storeFilter(data))
        } else if (filter.data.parentName !== selectedData[0].parent && filter.data.isDirectQuery) {
            consolelog('I am 3')
            data = dispatchMessageFormatter('', true, "Product Menu 48", selectedData[0].name, selectedData[0].parent,
                undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)
            store.dispatch(storeFilter(data))
        }
        else if (filter.data.parentName === selectedData[0].parent && filter.data.isDirectQuery) {
            consolelog('I am 4')
            data = dispatchMessageFormatter(filter.data.data, true, "Product Menu 53", selectedData[0].name, selectedData[0].parent,
                undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)
            store.dispatch(storeFilter(data))
        }
        else if ("/product/measurements" === selectedData[0].path && !filter.data.isDirectQuery) {
            consolelog('I am 5')
            let filterValue = filter.data.nestedSearchId !== undefined ? filter.data.nestedSearchId : ""//filter.data.searchId;
            let filterData = filterModelSelecterAndProcessData(filterValue, `${selectedData[0].parent}/${selectedData[0].name}`);
            data = dispatchMessageFormatter(filterData, filter.data.isDirectQuery, "Product Menu 60", selectedData[0].name, selectedData[0].parent,
                undefined, undefined, undefined, undefined, undefined, selectedData[0].name, filter.data.data, undefined)
            store.dispatch(menuHeaderPayload(data))
        }
        else if (filter.data.parentName !== selectedData[0].parent && !filter.data.isDirectQuery) {
            consolelog('I am 6')
            data = dispatchMessageFormatter(filter.data.data, filter.data.isDirectQuery, "Product Menu 66", selectedData[0].name,
                selectedData[0].parent, undefined, undefined, undefined, undefined, undefined, filter.data.selectedMenu, filter.data.data, undefined)
            store.dispatch(menuHeaderPayload(data))
        }
        history.push(selectedData[0].path, { "HeaderName": selectedData[0].name })
    }

    const menus = routes.filter(x => x.index === 3 && x.isChild && x.name !== 'Food Volumetrics').map((childData, index) => {
        return { label: childData.name, value: childData.name, data: childData }
    })

    const onBack = () => {
        let data = dispatchMessageFormatter('', true, "Product Menu 78", 'Summary', '/familyGroupAdmin',
            undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined)
        store.dispatch(storeFilter(data))
        history.push('/familyGroupAdmin/summary', { "HeaderName": 'Summary' })
    }

    return (
        <>
            <Card
                element="nav"
                hard
                className="ln-u-soft-ends"
                style={{ maxWidth: '15rem' }}
                aria-describedby="list-group-1"
            >
                <GridWrapper equalHeight>
                    <GridItem size="1">
                        <SelectField
                            className="selectedField"
                            name={"fieldNames.title"}
                            label=""
                            options={menus}
                            onChange={(e: any) => onChange(e, menus)}
                            value={selectedMenu}
                            required
                            defaultValue={selectedMenu}
                            placeholder=""
                        />

                    </GridItem>
                    {showBackBtn &&
                        <GridItem size="1/2">
                            <div style={{ 'display': 'inline' }}>
                                <button type="button" className="ln-c-button ln-c-button--outlined" onClick={onBack}>
                                    Back
                                </button>
                            </div>
                        </GridItem>
                    }
                </GridWrapper>
            </Card>
        </>
    )
}

export default ProductMenu